import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';

const UpgradePlanSection = ({
  isUpgradeOpen,
  handleOpenUpgradePlan,
  planData,
  plan,
  btnLoader,
  loadingPlanId,
  getClientSecret,
  capitalizeFirstLetter
}) => {
  return (
    <div className="w-full mx-auto mt-4">
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <button
          onClick={handleOpenUpgradePlan}
          className="w-full px-4 py-3 flex justify-between items-center focus:outline-none"
        >
          <span className="font-medium">Upgrade plan</span>
          <svg
            className={`w-5 h-5 transition-transform duration-200 ${isUpgradeOpen ? 'transform rotate-180' : ''}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={`transition-all duration-300 ease-in-out ${isUpgradeOpen ? 'max-h-fit opacity-100 overflow-auto scrollbar-thin scrollbar-webkit' : 'max-h-0 opacity-0'}`}
        >
          <p className="text-center text-xs font-lufga text-gray-600 bg-yellow-50 py-2 rounded-md mx-4 sm:mx-6 my-3">
            Please note: Promo prices do not apply when upgrading your plan. Thank you for understanding!
          </p>
          <div className="px-4 py-3 border-t border-gray-200 grid lg:grid-cols-2 gap-4">
            {planData?.map((item) => {
              if (plan.id !== item.id && item?.status === 'active') {
                return (
                  <div key={item.id} className="col-span-1">
                    <div className="bg-white rounded-xl shadow-md p-4 cursor-pointer border border-blue-100 my-2 flex flex-col h-full">
                      <div>
                        <h3 className="text-lg font-bold text-gray-900">{capitalizeFirstLetter(item.name)}</h3>
                        <div className="flex items-baseline mt-1">
                          <h3 className="text-xl font-semibold text-blue-600">
                            ${item.price}
                          </h3>
                          <span className="text-sm text-gray-600 ml-1">/ {item.billable}</span>
                        </div>
                        {item.discounted_amount > 0 && (
                          <p className="text-sm text-gray-500 line-through">${item.discounted_amount} / {item.billable}</p>
                        )}
                        <p className="text-sm text-gray-600 mt-2">{capitalizeFirstLetter(item.description)}</p>
                        <div className="mt-3">
                          {item.features?.map((feature, index) => (
                            <div key={index} className="flex items-center text-gray-700 text-xs mt-1">
                              <FaCheckCircle className="mr-2 text-blue-500 flex-shrink-0" />
                              <span>{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="mt-auto pt-4 w-full">
                        <button
                          onClick={plan.price > item.price ? 
                            () => { toast.error('Plans are not downgradable! Please contact our customer support lines. We are here to assist you!') } : 
                            () => { getClientSecret(item) }}
                          disabled={btnLoader}
                          className="bg-blue-500 hover:opacity-90 text-white py-2 px-4 rounded-md shadow-sm text-sm w-full">
                          {btnLoader && item.id === loadingPlanId ? 
                            <div className="flex justify-center">
                              <div className="animate-spin h-5 w-5 border-2 border-white rounded-full border-t-transparent"></div>
                            </div> : 
                            'Upgrade'
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePlanSection; 